<template>
  <div class="delivery_order">
    <!-- main frame -->
    <v-container grid-list-md fluid>
      <!-- part 1 DO detail  -->
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10" color="blue-grey lighten-5">
            <!-- <v-card-title>
              <v-icon large left>zoom_out_map</v-icon>
              <span class="title font-weight-heavy">Create DO</span>
            </v-card-title>-->

            <v-card-text>
              <v-layout wrap row justify-space-around>
                <!-- DO create date -->
                <v-flex xs2>
                  <v-menu
                    lazy
                    :close-on-content-click="true"
                    v-model="date_box"
                    transition="scale-transition"
                    offset-y
                    v-on:change="clearallfieldnew()"
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Date"
                      v-model="date"
                      v-on:change="clearallfieldnew()"
                      persistent-hint
                      readonly
                    ></v-text-field>

                    <v-date-picker
                      v-model="date"
                      @input="date_box = false"
                      v-on:change="clearallfieldnew()"
                      no-title
                      actions
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <!-- customer selection  -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="customer"
                    :items="customerList"
                    item-text="name"
                    item-value="id"
                    label="Customer"
                    ref="customer"
                    persistent-hint
                    return-object
                    small-chips
                  ></v-autocomplete>
                </v-flex>

                <!-- delivery driver selection  -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="delivery_driver"
                    :items="deliverydriverList"
                    item-text="username"
                    item-value="id"
                    label="Delivery by (may leave blank)"
                    ref="delivery_driver"
                    persistent-hint
                    return-object
                    small-chips
                  ></v-autocomplete>
                </v-flex>

                <!-- basket control  -->
                <v-flex xs4>
                  <v-text-field
                    v-model="basket_quantity"
                    v-on:change="basket_quantity = Math.max(Math.min(Math.round(basket_quantity), 9999999), 0)"
                    ref="basket_q"
                    type="number"
                    label="Empty Basket returned by customer (may ingore)"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs2>
                  <v-text-field
                    type="number"
                    outline
                    v-model="sewa"
                    label="sewa price"
                    placeholder="0.2"
                  ></v-text-field>
                </v-flex>
                <!-- button create do  -->
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- part 2 DO item -->
      <v-layout wrap row>
        <v-flex xs12>
          <v-card class="elevation-10">
            <v-card-text>
              <!--  insert item into DO -->
              <v-layout wrap row>
                <!--  Select Product -->
                <v-flex xs2>
                  <v-autocomplete
                    v-model="product"
                    :items="productList"
                    item-text="product_code_name"
                    item-value="id"
                    v-on:keyup.enter="getAvailableStock(),checkingProudctType(),VegeNext()"
                    v-on:change="getAvailableStock(),checkingProudctType()"
                    label="Vege"
                    ref="product"
                    chips
                    return-object
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.product_code_name }} &nbsp; &nbsp;
                      <v-avatar size="38">
                        <img :src="(baseUrl+'/product/vege_img/'+item.picture)" />
                      </v-avatar>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!--  Select Stock -->
                <v-flex xs2 v-if="limitDay != '0' ">
                  <v-select
                    v-model="available_stock"
                    :items="available_stockList"
                    item-text="date"
                    v-on:keyup.enter="AvailbleStockNext()"
                    label="Availble Stock"
                    ref="available_stock"
                    chips
                    return-object
                  >
                    <template slot="selection" slot-scope="{ item }">
                      {{ item.date }} &nbsp;
                      {{ item.available_weight }}kg
                    </template>
                    <template slot="item" slot-scope="{ item }">
                      {{ item.date }} &nbsp; &nbsp;
                      {{ item.available_weight }}kg
                    </template>
                  </v-select>
                </v-flex>

                <!--  Select Grade -->
                <v-flex xs2 v-if="setting_grade == true">
                  <v-autocomplete
                    v-model="grade"
                    :items="gradeList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="GradeNext()"
                    label="Grade"
                    ref="grade"
                    chips
                  ></v-autocomplete>
                </v-flex>

                <!--  Select Location -->
                <!-- <v-flex xs1 v-if="setting_location == true">
                  <v-autocomplete
                    v-model="location"
                    :items="locationList"
                    item-text="name"
                    item-value="name"
                    v-on:keyup.enter="LocationNext()"
                    label="Location"
                    ref="location"
                    chips
                  ></v-autocomplete>
                </v-flex> -->

             
                <!-- Type Price -->
                 <!-- v-on:change="price = Math.max(Math.min(price, 9999999), 0)" -->
                <v-flex xs1 v-if="setting_price == true">
                  <v-text-field
                    v-model="price"
                    v-on:keyup.enter="PriceNext();"
                   
                    ref="price"
                    type="number"
                    label="Price"
                    @focus="$event.target.select()"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Type Weight -->
                <v-flex xs2>
                  <v-text-field
                    v-if="product_type_need_weight==true"
                    v-model="weight"
                    v-on:keyup.enter="WeightNext()"
                    v-on:change="weight = Math.max(Math.min(weight, 9999999), 0.1)"
                    @keydown.tab.prevent="tabNext()"
                    @focus="$event.target.select()"
                    type="number"
                    ref="weight"
                    label="weight(kg)"
                    box
                  ></v-text-field>
                </v-flex>

                <!--  Type Quantity -->
                <v-flex xs1>
                  <v-text-field
                    v-model="quantity"
                    v-on:keyup.enter="QuantityNext()"
                    v-on:change="quantity = Math.max(Math.min(Math.round(quantity), 9999999), 1)"
                    @keydown.tab.prevent="tabNext()"
                    ref="qty"
                    type="number"
                    label="Qty"
                    @focus="$event.target.select()"
                    box
                  ></v-text-field>
                </v-flex>

                   <!--  Select Basket  -->
                <v-flex xs1 v-if="product_type_need_basket === true">
                  <v-autocomplete
                    v-model="basket_need"
                    :items="basket_needList"
                    item-text="text"
                    item-value="value"
                    v-on:keyup.enter="BasketNext()"
                    label="Basket"
                    ref="basket"
                    chips
                  ></v-autocomplete>
                </v-flex>


                <v-flex xs1>
                  <v-btn color="primary" @click="additemToDO(),tabNext()">
                    <v-icon>subdirectory_arrow_left</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>

              <!-- do item local table -->
              <v-layout>
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="local_do_stock"
                    disable-initial-sort
                    :rows-per-page-items="[100, 150, 200, 250]"
                    class="elevation-1"
                    height="60px"
                  >
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td width="10%">
                          <v-avatar size="38">
                            <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                          </v-avatar>
                        </td>
                        <td width="10%" class="text-xs-right">{{ props.item.product_name }}</td>
                        <td width="10%" class="text-xs-right">{{ props.item.grade }}</td>
                        <td width="10%" class="text-xs-right">{{ props.item.location }}</td>
                        <td class="text-xs-right">{{ props.item.quantity }}</td>

                        <td
                          style="word-wrap: break-word"
                          width="20%"
                          class="text-xs-left"
                        >{{ props.item.weight }}</td>
                        <td width="10%" class="text-xs-right">{{ props.item.price }}</td>
                        <td width="10%" class="text-xs-right">{{ props.item.date }}</td>
                        <td width="10%" class="text-xs-right">
                          <v-checkbox v-if="props.item.type=='basket'" v-model="props.item.basket" label="basket"></v-checkbox>
                        </td>

                        <td width="20%" class="text-xs-right">
                          <v-icon
                            medium
                            color="warning"
                            @click="edit(local_do_stock.map(function(x) {return x.product_image; }).indexOf(props.item.product_image))"
                          >build</v-icon>
                          <v-icon
                            medium
                            color="error"
                            @click="deleteDOitem(props.item)"
                          >delete_forever</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xl1>
                  <v-btn
                    color="primary"
                    :loading="saving"
                    :disabled="saving"
                    @click.native="save_do"
                  >Save</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Loading Dialog when vege adding (Overlay)  -->
    <v-dialog v-model="vege_adding_loading_dialog" overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Adding Vege: {{vege_adding_loading_value}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--  Dialog for edit -->
    <v-dialog v-model="edit_vege" width="200">
      <v-card>
        <v-card-text>
          <div v-for="(item,index) in edit_vege_array" :key="index">
            <input type="text" :value="item" style="width: 40px;border:1px solid #000000;" />
            <v-icon small color="error" @click="deleted_single_edidted_vege(index)">delete_forever</v-icon>
          </div>
        </v-card-text>
        <v-card-action>
          <v-btn small color="success" @click="save_edited_vege">save</v-btn>
          <v-btn small color="warning" @click="edit_vege=false">cancel</v-btn>
        </v-card-action>
      </v-card>
    </v-dialog>

    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="1500">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>

    <v-snackbar v-model="snackbar_print" :top="true" :right="true" :timeout="60000">
      DO created. 
      <!-- {{serverback_result_test}} -->
      <!-- <v-btn color="success" flat @click="fetch_do_detail(do_id_print)">Print</v-btn> -->
      <v-btn color="pink" flat @click="snackbar_print = false">Close</v-btn>
    </v-snackbar>

        <!-- Snackbar when axios method error catched  (jump out at top) -->
      <v-snackbar v-model="snackbar_test" :top="true"  :timeout="60000">
        上去{{number_test}}个
      <!-- <v-btn color="success" flat @click="fetch_do_detail(do_id_print)">Print</v-btn> -->
       <v-btn color="pink" flat @click="snackbar_test = false">Close</v-btn>
    </v-snackbar>



  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import moment from "moment";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
// import { throttle } from "lodash";
//import VWidget from "@/components/user_widget/vwidget";
//import delivery_order_list from "@/components/large_component/delivery_order_list";

export default {
  components: {
    //VWidget,
  },
  data() {
    return {
      //fixed
      snackbar_test:false,
      number_test:'',
      serverback_result_test:'',
      
      baseUrl: baseUrl,
      xx: "",
      //array

      customerList: [],
      deliverydriverList: [],
      productList: [],
      farmerList_WithSelectedProduct: [],
      gradeList: [],
      locationList: [],
      available_stockList: [],
      local_do_stock: [],
      headers: [
        { text: "Image", value: "product_image" },
        { text: "Veg", align: "right", value: "product_name" },
        { text: "Grade", align: "right", value: "grade" },
        { text: "Location", align: "right", value: "location" },
        { text: "Qty", align: "right", value: "quantity" },
        { text: "Weight/Box", align: "left", value: "weight" },
        // { text: "Qty", align: "right", value: "quantity" },
        { text: "RM", align: "right", value: "price" },
        { text: "Veg Stocked Date", align: "right", value: "date" },
        { text: "Basket", align: "right", value: "basket", sortable: false },
        { text: "Actions", align: "right", value: "action", sortable: false }
      ],
      do_array_for_print: [],
      basket_needList: [
        { text: "basket", value: true },
        { text: "no basket", value: false }
      ],
      edit_vege_array: [],

      //main value
      date: moment().format("YYYY-MM-DD"),
      customer: "",
      delivery_driver: "",
      product: "",
      available_stock: "",
      weight: "",
      quantity: "",
      price: "",
      grade: "",
      location: "",
      basket_quantity: "",
      sewa: "",
      basket: true,
      basket_need: "",

      new_grade: "",
      new_location: "",

      do_id_print: "",

      //logic control
      product_type_need_weight: true,
      product_type_need_basket: true,
      setting_grade: true,
      setting_location: true,
      setting_price: true,
      limitDay: "",
      saving: false,

      //others
      response_detail: "",
      vege_adding_loading_value: "",
      VegeLogo: "",

      // dialog snackbar date_box
      snackbar_print: false,
      setting_dialog: false,
      date_box: false,
      vege_adding_loading_dialog: false,
      snackbar_response: false,
      snackbar_no_connection: false,
      edit_vege: false,
      do_stock_weight_array: [],
      new_local_do_stock: []
    };
  },
  created() {
    this.getCustomer();
    this.getDeliveryDriver();
    this.getProduct();
    this.getGrade();
    this.getLocation();
    this.getImageLogo();
  },
  mounted() {
    this.intervalFetch();
  },
  computed: {},

  methods: {
    getCustomer() {
      const params = new URLSearchParams();
      params.append("get_customer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_customer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.customerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Customer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getDeliveryDriver() {
      const params = new URLSearchParams();
      params.append("get_driver", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_driver.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.deliverydriverList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Delivery Driver List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getGrade() {
      const params = new URLSearchParams();
      params.append("get_grade", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.gradeList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Grade List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getLocation() {
      const params = new URLSearchParams();
      params.append("get_location", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.locationList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Location List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    save_do() {
      this.saving = true;
      this.new_local_do_stock = [];
      //checking whether data filled
      if (this.date && this.customer.id  && this.local_do_stock.length > 0) {
        const params = new URLSearchParams();
        params.append("create_do", "create_do");
        params.append("date", this.date);
        params.append("basket_quantity", this.basket_quantity);
        params.append("customer_id", this.customer.id);
        params.append("delivery_driver_id", this.delivery_driver.id);

        var new_local_do_stock = [];

        for (var i = 0; i < this.local_do_stock.length; i++) {
          var multi_weight = this.local_do_stock[i].weight.split(",");

          this.do_stock_weight_array = [];

          for (var j = 0; j < multi_weight.length; j++) {
            this.calc(multi_weight[j]);
          }
          for (var g = 0; g < this.do_stock_weight_array.length; g++) {
            new_local_do_stock.push({
              product_image: this.local_do_stock[i].product_image,
              product_name: this.local_do_stock[i].product_name,
              product_id: this.local_do_stock[i].product_id,
              grade: this.local_do_stock[i].grade,
              location: this.local_do_stock[i].location,
              weight: this.do_stock_weight_array[g].weight,
              quantity: this.do_stock_weight_array[g].quantity,
              price: this.local_do_stock[i].price,
              date: this.local_do_stock[i].date,
              type: this.local_do_stock[i].type,
              basket: this.local_do_stock[i].basket
            });
          }
        }

        // for(var z=0;z<new_local_do_stock.length;z++){
        //   this.snackbar_test=true;
        //   this.number_test=z+1;
        // }

        params.append("do_item_array", JSON.stringify(new_local_do_stock));
        params.append("sewa", this.sewa);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
          data: params
        })
          .then(response => {
            console.log(response);
            if (response.data.error == false) {
              //set response to selected data
              // this.serverback_result_test=response.data.message;
              this.snackbar_print = true;
              this.clearallfieldnew();
              this.saving = false;
              this.do_id_print = response.data.do_id;
              this.$emit("update", "someValue");
            } else if (response.data.error == true) {
              this.saving = false;
              this.snackbar_print = false;
              this.snackbar_response = true;
              this.response_detail = response.data.message;
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar_connection = true;
            this.saving = false;
          });
      } else {
        this.snackbar_response = true;
        this.saving = false;

        this.response_detail = "Please fill in the detail & vege";
      }
    },
    calc(weight) {
      for (var g = 0; g < this.do_stock_weight_array.length; g++) {
        if (this.do_stock_weight_array[g].weight == weight) {
          this.do_stock_weight_array[g].quantity =
            this.do_stock_weight_array[g].quantity + 1;
          return;
        }
      }

      this.do_stock_weight_array.push({
        weight: weight,
        quantity: 1
      });
    },
    getProduct() {
      const params = new URLSearchParams();
      params.append("getAllProduct", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/product/product.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.productList = response.data.data;
            this.clearallfield();
          } else if (response.data.error == true) {
            console.log("Product List Problem" + response.data.message);
            this.clearallfield();
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    getAvailableStock() {
      this.available_stockList = [];
      const params = new URLSearchParams();
      params.append(
        "getAvailableStockGroupByDate",
        "getAvailableStockGroupByDate"
      );
      params.append("product_id", this.product.id);
      params.append("limit_day", this.limitDay);
      params.append("date", this.date);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.available_stockList = response.data.data;
            this.snackbar_response = false;
            this.grade = "";
            this.location = "";
            this.basket = "";
            // this.weight = "";
            this.quantity = "";
            this.price = "";
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.available_stockList = [];

            this.grade = "";
            this.location = "";
            this.basket = "";
            this.quantity = "";
            this.price = "";

            // this.available_stock_with_selected_farmer = [];
            // this.picked_stock_with_do_and_vege = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    additemToDO() {
      //checking whether data filled
      console.log(this.weight);
      if (this.product.id && this.weight && this.quantity) {
        if (this.grade == "" || this.grade== null) {
          this.grade = "unknown";
        }
        if (this.location == "" || this.location== null) {
          this.location = "unknown";
        }
        if (this.price == "" || this.price== null) {
          this.price = "0";
        }

        for (var i = 0; i < this.local_do_stock.length; i++) {
          if (
            this.local_do_stock[i].grade == this.grade &&
            this.local_do_stock[i].location == this.location &&
            this.local_do_stock[i].product_id == this.product.id &&
            this.local_do_stock[i].date == this.available_stock.date &&
            this.local_do_stock[i].basket == this.basket_need &&
            this.local_do_stock[i].price == this.price
          ) {
            for (var j = 0; j < this.quantity; j++) {
              this.local_do_stock[i].weight =
                this.local_do_stock[i].weight + "," + this.weight;
               this.local_do_stock[i].quantity++;

            }

            return;
          }
        }
        var single_weight = "";

        for (var i = 0; i < this.quantity; i++) {
          single_weight =
            (single_weight == "" ? "" : single_weight + ",") + this.weight;
        }

        this.local_do_stock.push({
          product_image: this.product.picture,
          product_name: this.product.name,
          product_id: this.product.id,
          grade: this.grade,
          location: this.location,
          weight: single_weight,
          quantity: parseFloat(this.quantity),
          price: parseFloat(this.price).toFixed(2),
          date: this.available_stock.date,
          type: this.product.type,
          basket: this.basket_need
        });
      } else {
        this.snackbar_response = true;
        this.response_detail = "Please fill in the detail";
      }
    },
    deleteDOitem(item) {
      const index = this.local_do_stock.indexOf(item);
      this.local_do_stock.splice(index, 1);
    },
    checkingProudctType() {
      //       if (this.product.type.trim() == "box") {
      //         this.product_type_need_basket = false;

      //         this.product_type_need_weight = false;

      //         this.weight = "1";
      //       } else {
      //         this.product_type_need_weight = true;
      //         this.product_type_need_basket = true;
      //         this.weight = "";
      //       }
      // /////////////////
      //       if (this.product.type.trim() == "non-basket") {
      //         this.product_type_need_basket = false;
      //         this.basket = false;
      //       } else {
      //         this.product_type_need_basket = true;
      //         this.basket = false;
      //       }

      if (this.product.type.trim() == "box" || this.product.type.trim() == "bag"|| this.product.type.trim() == "pcs" || this.product.type.trim() == "pkt") {
        this.product_type_need_basket = false;
        this.basket_need=false;
        this.product_type_need_weight = false;
        this.basket = false;
        this.weight = "1";
      } else if (this.product.type.trim() == "non-basket") {
        this.product_type_need_basket = false;
        this.product_type_need_weight = true;
        this.basket_need=false;
        this.basket = false;
        this.weight = "";
      } else {
        this.product_type_need_basket = true;
        this.product_type_need_weight = true;
        this.basket_need=true;
        this.basket = true;
        this.weight = "";
      }
    },
    VegeNext_item() {
      if (this.limitDay != "0" && this.available_stockList.length > 0) {
        this.$refs.available_stock.focus();
        this.$refs.available_stock.activateMenu();
      } else if (this.setting_grade == true) {
        this.$refs.grade.activateMenu();
        this.$refs.grade.focus();
      }
      //  else if (this.setting_location == true) {
      //   this.$refs.location.focus();
      //   this.$refs.location.activateMenu();
      // } 
      else if (this.product.type == "box" || this.product.type == "bag" || this.product.type == "pkt"|| this.product.type == "pcs" ) {
        this.$refs.qty.focus();
      } else {
        this.$refs.weight.focus();
      }
    },
    VegeNext() {
      var self = this;
      setTimeout(function() {
        self.VegeNext_item();
      }, 200);
    },
    AvailbleStockNext() {
      if (this.setting_grade == true) {
        this.$refs.grade.focus();
        // this.grade="unknown";
        this.$refs.grade.activateMenu();
      }
      //  else if (this.setting_location == true) {
      //   this.$refs.location.focus();
      //   this.$refs.location.activateMenu();
      //   // this.location="unknown";

      // }
       else if (this.setting_price == true) {
        this.$refs.price.focus();
        // this.price="0";

      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    GradeNext() {
      // if (this.setting_location == true) {
      //   this.$refs.location.focus();
      //   this.$refs.location.activateMenu();
      //   // this.location="unknown";
      // } else 
      if (this.setting_price == true) {
        this.$refs.price.focus();
        // this.price="0";
      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    LocationNext() {

      if (this.setting_price == true) {
        this.$refs.price.focus();
        // this.price="0";

      } else if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    BasketNext() {
      // if (this.setting_price == true) {
      //   this.$refs.price.focus();
      // } else if (this.product_type_need_weight == true) {
      //   this.$refs.weight.focus();
      // } else {
      //   this.$refs.qty.focus();
      // }
    },
    PriceNext() {
      if (this.product_type_need_weight == true) {
        this.$refs.weight.focus();
      } else {
        this.$refs.qty.focus();
      }
    },
    WeightNext() {
      this.$refs.qty.focus();
    },
    QuantityNext() {
      this.additemToDO();
      if (this.product_type_need_weight == true) {
        this.weight = "";
        this.quantity = "1";
        this.$refs.weight.focus();
      } else {
        this.quantity = "";
        this.$refs.qty.focus();
      }
    },
    clearallfield() {
      this.customer = "";
      this.delivery_driver = "";
      this.available_stockList = [];
      this.available_stock = "";
      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
      this.basket_need = "";
    },
    clearallfieldnew() {
      this.basket_quantity = "";
      this.local_do_stock = [];
      this.customer = "";
      this.delivery_driver = "";
      this.available_stockList = [];
      this.available_stock = "";
      this.weight = "";
      this.quantity = "";
      this.price = "";
      this.grade = "";
      this.location = "";
      this.product = "";
      this.basket_need = "";
    },
    tabNext() {
      this.$refs.product.focus();
      this.$refs.product.activateMenu();
      this.product = "";
      this.available_stockList = [];
      this.available_stock = "";
      this.grade = "";
      this.location = "";
      this.basket_need = "";
      this.price = "";
      this.weight = "";
      this.quantity = "";
    },
    intervalFetch: function() {
      setInterval(() => {
        this.limitDay = localStorage.stocked_day_limit;
        this.setting_grade = localStorage.setting_grade;
        this.setting_location = localStorage.setting_location;
        this.setting_price = localStorage.setting_price;
        if (this.setting_grade == "true") {
          this.setting_grade = true;
        } else {
          this.setting_grade = false;
        }
        if (this.setting_location == "true") {
          this.setting_location = true;
        } else {
          this.setting_location = false;
        }

        if (this.setting_price == "true") {
          this.setting_price = true;
        } else {
          this.setting_price = false;
        }
      }, 500);
    },
    
    getImageLogo() {
      const toDataURL = url =>
        fetch(url)
          .then(response => response.blob())
          .then(
            blob =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
          );

      toDataURL(require("@/assets/image/vege_trading.jpg")).then(dataUrl => {
        this.VegeLogo = dataUrl;
      });
    },
    fetch_do_detail(do_id) {
      const params = new URLSearchParams();
      params.append("getDeliveryOrderListByID", "getDeliveryOrderListByID");
      params.append("do_id", do_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            var array = response.data.data;

            var date = array[0].created_at;
            var customer_name = array[0].customer_name;
            var basket_quantity = array[0].basket_quantity;

            this.fetch_array_for_print(
              do_id,
              date,
              customer_name,
              basket_quantity
            );
          } else if (response.data.error == true) {
            // this.errors = response.data.message;
            this.po_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_array_for_print(do_id, date, customer_name, basket_quantity) {
      const params = new URLSearchParams();
      params.append("getDOStock", "getDOStock");
      params.append("do_id", do_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.do_array_for_print = response.data.data;
            this.print_do(do_id, date, customer_name, basket_quantity);
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.do_array_for_print = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    print_do(do_id, date, customer_name, basket_quantity) {
      var doc = new jsPDF();

      doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(40, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(41, 20, localStorage.address);
      doc.text(41, 25, "Phone:" + localStorage.phone);
      doc.text(41, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "ID: ");
      doc.text(158, 20, "Date: ");
      doc.text(148, 25, "Customer: ");
      doc.text(137, 40, "Basket returned: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#DO" + do_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(customer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(10);
      doc.setFontStyle("bold");
      doc.text(170, 40, basket_quantity);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Customer Vege Date:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(55, 45, date);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      var formatted_array = [];
      for (var i = 0; i < this.do_array_for_print.length; i++) {
        formatted_array[i] = this.do_array_for_print[i];

        this.$set(formatted_array[i], "row_no", i + 1);
      }

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" }
      ];

      var grade_array = { header: "Grade", dataKey: "grade" };
      var location_array = { header: "Location", dataKey: "location" };

      if (localStorage.setting_location == "true") {
        invoice_pdf_header.splice(2, 0, location_array);
      }
      if (localStorage.setting_grade == "true") {
        invoice_pdf_header.splice(2, 0, grade_array);
      }

      doc.autoTable({
        pageBreak: "auto",
        startY: 55,
        theme: "grid",
        showHead: "firstPage",
        didDrawPage: function(data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);
          doc.setFontStyle("normal");

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, 100, pageHeight - 10);
        },
        headStyles: {
          fillColor: [224, 224, 224],
          textColor: 10,
          fontSize: 11
        },

        columnStyles: {
          row_no: { columnWidth: 8, fontStyle: "bold" },
          product_name: { columnWidth: 25, fontStyle: "bold" },
          grade: { columnWidth: 15 },
          location: { columnWidth: 15 },
          weight: { columnWidth: 15 },
          quantity: { columnWidth: 15, fontStyle: "bold" }
        },
        columns: invoice_pdf_header,
        body: formatted_array
      });

      //////after auto table
      if (doc.autoTable.previous.finalY > 230) {
        doc.addPage();
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(15, 20, 192, 20);

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, 26, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(140, 37, 192, 37);

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, 42, "Name:");
        doc.text(140, 47, "Date:");
      } else {
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(
          140,
          doc.autoTable.previous.finalY + 42,
          192,
          doc.autoTable.previous.finalY + 42
        );

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
        doc.text(140, doc.autoTable.previous.finalY + 52, "Date:");
      }

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      invoice_pdf_header = [
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" }
      ];
      doc.save("DO-" + customer_name + "-" + date + ".pdf");
    },
    edit(item) {
      console.log(item);
      this.edit_vege_index = "";
      this.edit_vege_index = item;

      this.edit_vege = true;
      this.edit_vege_array = [];
      var vege_splited = [];
      vege_splited = this.local_do_stock[item].weight.split(",");

      for (var i = 0; i < vege_splited.length; i++) {
        this.edit_vege_array.push(vege_splited[i]);
      }
    },
    save_edited_vege() {
      var vege = "";
      for (var i = 0; i < this.edit_vege_array.length; i++) {
        vege = (vege == "" ? "" : vege + ",") + this.edit_vege_array[i];
      }

      this.local_do_stock[this.edit_vege_index].weight = vege;
      this.edit_vege = false;
    },
    deleted_single_edidted_vege(index) {
      this.edit_vege_array.splice(index, 1);
    }
  }
};
</script>

